import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { OwnerType, TimelineIconType } from '../../../constants/ComponentTypes';
import moment from 'moment';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions/OrderDashboard';
import { FLAG } from '../../../constants/Constants';

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  box: {
    padding: '15px 25px',
    background: '#F2FFF8',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: 5,
    boxSizing: 'border-box',
    marginBottom: 25,
    cursor: 'pointer',
  },

  detail: {
    fontSize: 14,
    marginTop: 10,
    color: '#3D8D5F',
  },

  circle: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 5,
    verticalAlign: 'text-top',
    background: '#3D8D5F',
  },
});

class AppointmentNotification extends React.Component {
  state = {
    checkedNotifications: JSON.parse(localStorage.getItem('checked_letter_dashboard_notifications') || '[]')
  }

  componentDidMount() {
    let query = this.filterValueToQuery();
    !this.props.isDemo && this.props.getAppointmentNotifications({
      ...query,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      let query = this.filterValueToQuery();
      !this.props.isDemo && this.props.getAppointmentNotifications({
        ...query,
      });
    }
  }

  filterValueToQuery = (ownerType = this.props.ownerType) => {
    let data = {};

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  handleClick = (item) => {
    // 既に同じIDのデータがローカルストレージに保存されている場合は何もしない
    if (this.state.checkedNotifications.some(notification => notification.id === item.id)) {
      return;
    }
    // 新しくチェックされた通知
    const newData = { id: item.id, created_at: item.created_at };
    const newCheckedNotifications = [...this.state.checkedNotifications, newData];
    // 通知対象は1週間以内のデータなので1週間より前のデータをローカルストレージから排除する
    const dayCountAtWeek = 7;
    const weekAgo = moment().subtract((dayCountAtWeek + 1), 'days');
    const filteredNotifications = newCheckedNotifications.filter(
      notification => moment(notification.created_at) >= weekAgo
    );
    // デモでない場合はローカルストレージに保存する
    if (!this.props.isDemo) {
      localStorage.setItem('checked_letter_dashboard_notifications', JSON.stringify(filteredNotifications));
    }
    this.setState({ checkedNotifications: newCheckedNotifications });

    // タイムラインのページに遷移
    // タイムラインから戻った際にダッシュボードのチーム/個人選択を復元するためstateを渡す
    const dashboardState = { pathname: "/order-dashboard", ownerType: this.props.ownerType };
    if (item && item.executive_person_id) {
      this.props.goTo(`/executive-list/${item.executive_person_id}/timeline`, dashboardState);
    }
    if (item && item.address_id) {
      this.props.goTo(`/house-list/${item.address_id}/timeline`, dashboardState);
    }
  };

  render() {
    const { classes, appointmentNotifications, isDemo } = this.props;
    // 通知がないかつデモモードでない場合は何も表示しない
    if (!appointmentNotifications && !isDemo) {
      return <div></div>;
    }

    // デモの場合はでもデータに差し替え
    const displayNotifications = isDemo ? AppointmentNotification.DEMO_DATA : appointmentNotifications;

    const uncheckedNotifications = displayNotifications.filter(item => !this.state.checkedNotifications.some(
      notification => notification.id === item.id)
    );

    return (
      <div className={classes.root}>
        {uncheckedNotifications.map((item, i) => (
          <div className={classes.box} key={i} onClick={() => this.handleClick(item)}>
            <Typography variant="display1" style={{ color: '#3D8D5F', fontSize: 16 }}>
              フォローコールにて商談を獲得しました！
            </Typography>
            <div className={classes.detail}>
              <span className={classes.circle}></span>
              商談を獲得した日：{moment(item.created_at).format("YYYY年MM月DD日")}
              <span style={{ marginLeft: 20 }}>{item.follow_call_order_address.company} {item.follow_call_order_address.name}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

AppointmentNotification.propTypes = {
  classes: PropTypes.object.isRequired,
  isDemo: PropTypes.bool,
  appointmentNotifications: PropTypes.array,
  getAppointmentNotifications: PropTypes.func,
  ownerType: PropTypes.string,
  goTo: PropTypes.func,
};

AppointmentNotification.DEMO_DATA = [
  {
    "id": 1,
    "created_at": "2020-07-09 20:59:47",
    "follow_call_order_address": {
      "name": "加川光徳",
      "company": "株式会社ケーヒン",
    }
  },
  {
    "id": 2,
    "created_at": "2020-07-09 16:56:28",
    "follow_call_order_address": {
      "name": "石附栄一",
      "company": "東武鉄道株式会社",
    }
  },
  {
    "id": 3,
    "created_at": "2020-07-09 16:48:14",
    "follow_call_order_address": {
      "name": "原口達哉",
      "company": "日本生命保険相互会社",
    }
  },
  {
    "id": 4,
    "created_at": "2020-07-09 16:44:33",
    "follow_call_order_address": {
      "name": "木本国広",
      "company": "日本生命保険相互会社",
    }
  }
];

const mapStateToProps = (state) => {
  return {
    isDemo: state.accountSetting.showDemoData,
    // [商談ステータス獲得通知]
    appointmentNotifications: state.timeline.appointmentNotifications.toIndexedSeq().toArray(),
  };
};

const mapDispatchToProps = (dispatch) => {
  // すでに閲覧済みのものはexcept_idsに入れる
  const notifications = JSON.parse(localStorage.getItem('checked_letter_dashboard_notifications')) || [];
  const ids = notifications.map(notification => notification.id);

  return {
    getAppointmentNotifications(data) {
      // 1週間以内にクローザーもしくは、リサーチャー(念の為)が取得した、商談獲得を5件まで取得する
      const dayCountAtWeek = 7;
      dispatch(actions.getAppointmentNotifications(
        {
          ...data,
          'paging': 1,
          'page': 1,
          'per_page': 5,
          'is_latest': FLAG.ON,
          'created_at_from': moment().subtract(dayCountAtWeek, 'day').format('YYYY-MM-DD'),
          'with_follow_call_order_address': FLAG.ON,
          'except_ids': ids,
          'types': [TimelineIconType.FOLLOW_CALL_USER_STATUS, TimelineIconType.RESEARCHER_USER_STATUS],
        }
      ))
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentNotification));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/AppointmentNotification.jsx